import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ExchangeRates from './ExchangeRates';
import mapExchangeRates from './mapExchangeRates';
import RatesErrorResponse from './RatesErrorResponse';

export interface Result {
	items: ExchangeRates[];
}

export default async function findExchangeRates(
	client: ApiClient,
	userId: string,
	groupId: string,
	type: string | null,
	date: Date | null
): Promise<Result> {
	const url = parseTemplate('users/{userId}/exchange-rates{?productGroupId,type,date}');
	try {
		const request = await client.fetch(
			url.expand({
				userId,
				productGroupId: groupId,
				type,
				date: date ? formatApiDate(date) : null,
			})
		);

		const response = await request.json();
		return { items: response.items.map(mapExchangeRates) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new RatesErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
